import { canReadLevelThreeWhitelist } from '@esentai/core/features/parkingLevelThreeWhitelist/permissions';
import { Button, Tab, Tabs } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import Breadcrumbs from '@/components/Breadcrumbs';
import Link from '@/components/Link';
import Page from '@/components/Page';
import PageContent from '@/components/PageContent';
import PageHeader from '@/components/PageHeader';
import PageTitle from '@/components/PageTitle';
import PageTitleLink from '@/components/PageTitleLink';
import CanView from '@/containers/CanView';
import { ROUTE_PATH as ROUTE_PARKING_LEVEL_THREE_WHITELIST_PATH } from '@/features/parkingLevelThreeWhitelistPage/consts';
import { ROUTE_PATH as ROUTE_PARKING_TOWER_STOP_LIST_PATH } from '@/features/parkingTowerStopListPage/consts';
import { ROUTE_PATH as ROUTE_PARKING_DYNAMIC_FILTER_PATH } from '@/features/parkingWhitelistDynamicFilterPage/consts';
import { ROUTE_PATH as ROUTE_PARKING_GROUPS_PAGE } from '@/features/parkingWhitelistGroupsPage/consts';
import { ROUTE_PATH as ROUTE_PARKING_WHITELIST_PATH } from '@/features/parkingWhitelistPage/consts';
import { ROUTE_PATH as ROUTE_PARKING_STATIC_FILTER_PATH } from '@/features/parkingWhitelistStaticFilterPage/consts';

import Table from './Table';

class ParkingWhitelists extends Component {
  static propTypes = {
    error: PropTypes.any,
    parkingWhitelistIds: PropTypes.arrayOf(PropTypes.any).isRequired,
    isLoading: PropTypes.bool.isRequired,
    totalCount: PropTypes.number.isRequired,
    history: PropTypes.object.isRequired,
  };

  static defaultProps = {
    error: null,
  };

  render() {
    const {
      error,
      parkingWhitelistIds,
      isLoading,
      totalCount,
      classes,
    } = this.props;

    return (
      <Page>
        <PageHeader borderBottom gutterBottom={false}>
          <Breadcrumbs />
          <PageTitle
            style={{
              marginBottom: 30,
              display: 'flex',
              gap: 20,
              justifyContent: 'start',
              placeItems: 'end',
              flexWrap: 'wrap',
            }}
            gutterBottom={false}
          >
            <PageTitle style={{ margin: 0 }} to={ROUTE_PARKING_WHITELIST_PATH}>
              Whitelist Тимирязева
            </PageTitle>
            <PageTitleLink
              to={ROUTE_PARKING_TOWER_STOP_LIST_PATH}
              style={{ margin: 0 }}
            >
              Stoplist Tower
            </PageTitleLink>
            <CanView permission={canReadLevelThreeWhitelist}>
              <PageTitleLink
                style={{ margin: 0 }}
                to={ROUTE_PARKING_LEVEL_THREE_WHITELIST_PATH}
              >
                Whitelist P3
              </PageTitleLink>
            </CanView>
          </PageTitle>
        </PageHeader>

        <PageContent className={classes.tableBlock}>
          <Tabs value={0} style={{ marginBottom: 20 }}>
            <Tab
              style={{
                fontSize: 24,
                maxWidth: 500,
                textTransform: 'capitalize',
                fontWeight: 300,
              }}
              label="Список пользоваталей"
            />
            <Tab
              onClick={() => this.props.history.push(ROUTE_PARKING_GROUPS_PAGE)}
              style={{
                fontSize: 24,
                maxWidth: 500,
                textTransform: 'capitalize',
                fontWeight: 300,
              }}
              label="Группы"
            />
          </Tabs>
          <div className={classes.buttonsWrapper}>
            <div className={classes.reportWrapper}>
              <Link to={ROUTE_PARKING_DYNAMIC_FILTER_PATH}>
                <Button
                  variant="outlined"
                  color="default"
                  size="small"
                  className={classes.button}
                >
                  Динамичный список
                </Button>
              </Link>
              <Link to={ROUTE_PARKING_STATIC_FILTER_PATH}>
                <Button
                  variant="outlined"
                  color="default"
                  size="small"
                  className={classes.button}
                >
                  Статичный список
                </Button>
              </Link>
            </div>
          </div>
          <Table
            error={error}
            items={parkingWhitelistIds}
            isLoading={isLoading}
            totalCount={totalCount}
          />
        </PageContent>
      </Page>
    );
  }
}

export default ParkingWhitelists;
